import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const BillEditor = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showGuestEdit, setShowGuestEdit] = useState(false);
// const [localGuest, setLocalGuest] = useState(location.state.guest);

  // const guests = {
  //   id: JSON.parse(location.state.guest_ids).id,
  //   name: JSON.parse(location.state.guest_ids).name,
  // };

const [guest, setGuest] = useState(location?.state?.guests?.[0] ?? null);
console.log(location.state);

  // guest form state
  const [guestData, setGuestData] = useState({
    companyName: '',
    gstin: ''
  })

useEffect(() => {
  if (showGuestEdit && guest) {
    const hasComma = guest.name.includes(',');
    const companyName = hasComma ? guest.name.split(',')[0].trim() : '';

    setGuestData({
      companyName,
      gstin: guest.is_com == 0 ? '' : guest.contact
    });
  }
}, [showGuestEdit, guest]);

 const handleGuestChange = (e) => {
    const { name, value } = e.target;
    setGuestData(prev => ({ ...prev, [name]: value }));
  };


  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };


  
  const [formData, setFormData] = useState({
    booking_id: location.state.booking_id,
    guest_data: location.state.guest_ids,
    room_id: location.state.room_id,
    room_no: location.state.room_no,
    from_date: location.state.from_date || "",
    to_date:
      location.state.to_date === "0000-00-00 00:00:00"
        ? getCurrentDateTime()
        : location.state.to_date,
    no_of_stayers: location.state.no_of_stayers || 1,
    total_amount: location.state.total_amount || 0,
    advance_amount: location.state.advance_amount || 0,
    food_price: location.state.food_order_total,
    remarks: location.state.remarks,
    extra_charges: location.state.extra_charges || 0,
    payment_method: location.state.payment_method || "",
    rest_amount: location.state.last_amount,
    tax_rate: location.state.tax_rate || 0,
    tax_amount: location.state.tax_amount || 0,
    food_tax_rate: location.state.food_tax_rate || 0,
    food_tax_amount: location.state.food_tax_amount || 0,
    due_collected: 0,
    collected_on: getCurrentDateTime(),
    due_method: 'Cash',
    collected_by: 'Admin',
    due_remark: ''
  });

    const [multiPayments, setMultiPayments] = useState([{ method: "", amount: "" }]);
  const [showMultiPayUI, setShowMultiPayUI] = useState(false);

  useEffect(() => {
  const paymentMethod = formData.payment_method || "";

  if (paymentMethod.startsWith("Multiple Method |")) {
    // parse multiple methods
    const entries = paymentMethod
      .replace("Multiple Method | ", "")
      .split(" | ")
      .map((item) => {
        const [method, amount] = item.split("-");
        return { method: method || "", amount: amount || "" };
      });

    setMultiPayments(entries);
    setShowMultiPayUI(true);
  } else if (paymentMethod) {
    // single payment method
    setShowMultiPayUI(false);
  } else {
    // no method selected yet
    setShowMultiPayUI(false);
  }
}, [formData.payment_method]);


const guests = React.useMemo(() => {
  if (!formData.guest_data) return { id: [], name: [] };
  try {
    const parsed = JSON.parse(formData.guest_data);
    return {
      id: parsed.id || [],
      name: parsed.name || [],
    };
  } catch {
    return { id: [], name: [] };
  }
}, [formData.guest_data]);

  // Handle form changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleNumberChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: parseFloat(value) || 0,
    }));
  };


  const calculateGSTAmount = (totalAmount, gstRate) => {
    return (totalAmount * gstRate) / 100;
  };


  const getRemainingAmount = (data) => {
  const tax = calculateGSTAmount(data.total_amount, data.tax_rate);
// console.log({
//   rest_amount: data.rest_amount,
//   extra_charges: data.extra_charges,
//   tax,
//   advance_amount: data.advance_amount,
//   due_collected: data.due_collected,
// });


  return (
        // Number(data.rest_amount)
    (Number(data.total_amount) +
        Number(data.extra_charges) +
    tax -         (Number(data.rest_amount) +  Number(data.advance_amount)))

    // Number(data.rest_amount) -
    // (Number(data.advance_amount) + Number(data.due_collected))
  );
};


    const handleMultiPaymentChange = (index, key, value) => {
    const updated = [...multiPayments];
    updated[index][key] = value;
    setMultiPayments(updated);
  };

  // Add a new payment method entry
  const handleAddPaymentMethod = () => {
    setMultiPayments([...multiPayments, { method: "", amount: "" }]);
  };

  // Finalize multiple payment methods and update formData.payment_method
  const finalizeMultiplePayment = () => {
    const methodString = multiPayments
      .filter((entry) => entry.method && entry.amount)
      .map((entry) => `${entry.method}-${entry.amount}`)
      .join(" | ");

    if (methodString) {
      setFormData((prev) => ({
        ...prev,
        payment_method: `Multiple Method | ${methodString}`,
      }));
    } else {
      setFormData((prev) => ({ ...prev, payment_method: "" }));
    }
    setShowMultiPayUI(false);
  };


  const handlePaymentMethodChange = (e) => {
    const value = e.target.value;
    if (value === "Multiple Method") {
      // If existing multi payments, parse them; else initialize empty
      if (formData.payment_method.startsWith("Multiple Method | ")) {
        const entries = formData.payment_method
          .replace("Multiple Method | ", "")
          .split(" | ")
          .map((item) => {
            const [method, amount] = item.split("-");
            return { method: method || "", amount: amount || "" };
          });
        setMultiPayments(entries);
      } else {
        setMultiPayments([{ method: "", amount: "" }]);
      }
      setShowMultiPayUI(true);
    } else {
      setFormData((prev) => ({
        ...prev,
        payment_method: value,
      }));
      setShowMultiPayUI(false);
    }
  };


  const handleDueMethodChange = (e) => {
    const value = e.target.value;
  
      setFormData((prev) => ({
        ...prev,
        due_method: value,
      }));
  };


  const handleSubmitEdit = (e) => {
    e.preventDefault();

  const remainingAmount = getRemainingAmount(formData);

  if (remainingAmount < (Number(formData.due_collected))) {
    props.handleToast({
      toastMsg: "Invalid Pay Amount: Paid amount exceeds total bill.",
      toastColor: "#FF0000",
    });
    return;
  }

          props.handleLoading();


    formData.tax_amount = calculateGSTAmount(
      formData.total_amount,
      formData.tax_rate
    );
    formData.food_tax_amount = calculateGSTAmount(
      formData.food_price,
      formData.food_tax_rate
    );
   
    

formData.rest_amount =
  (Number(formData.total_amount || 0) - Number(formData.rest_amount)) +
  Number(formData.extra_charges || 0) +
  Number(formData.tax_amount || 0) +
  Number(formData.rest_amount) -
  (Number(formData.advance_amount || 0) +
   Number(formData.due_collected || 0));
    
          // formData.advance_amount = Number(formData.advance_amount) + Number(formData.due_collected);

  //   const restAmount =
  // Number(formData.total_amount) -
  // Number(formData.due_collected) -
  // Number(formData.advance_amount) +
  // Number(formData.extra_charges || 0) +
  // Number(formData.tax_amount || 0);


console.log(formData.advance_amount);
console.log(formData.rest_amount);

    axios
      .put(
        `https://api.dectwinhotel.com/api/${props.id}_bookings/bill-editor1`,
        formData
      )
      .then((response) => {
        props.closeLoading();
        props.handleToast({
          toastMsg: "Invoice Edited Successfully!!!",
          toastColor: "#4CAF50",
        });
        navigate("/admin/dashboard");
      })
      .catch((error) => {
        props.closeLoading();
        props.handleToast({
          toastMsg:
            "Something went wrong! Enter please try again or check Internet",
          toastColor: "#FF0000",
        });
      });
  };


const handleSubmitGuestEdit = async (e) => {
  e.preventDefault();
  props.handleLoading();

  console.log(guestData);

  let guestNamePart = '';
  if (guest.name.includes(',')) {
    const parts = guest.name.split(',');
    guestNamePart = parts[1].trim();
  } else {
    guestNamePart = guest.name.trim();
  }

  const fullCompanyName = `${guestData.companyName}, ${guestNamePart}`;

  try {
    const payload = {
      guestId: guest.id,
      bookingId: location.state.booking_id,
      name: fullCompanyName,
      contact: guestData.gstin,
      comp_contact: guest.contact,
      is_com: guest.is_com
    };

    const response = await fetch(
      `https://api.dectwinhotel.com/api/${props.id}_guests/update-guest-bill`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      }
    );

    const result = await response.json();
    if (response.ok) {
const storedGuests = JSON.parse(localStorage.getItem("guests")) || [];
      const guestIndexInStorage = storedGuests.findIndex(g => g.id === guest.id);

      if (guestIndexInStorage !== -1) {
        const guestInStorage = storedGuests[guestIndexInStorage];
        // console.log(guestData, guest);

        if (guestInStorage.is_com === 0 || guestInStorage.is_com === '0') {
          storedGuests[guestIndexInStorage] = {
            ...guestInStorage,
            name: fullCompanyName,
            contact: guestData.gstin,
            comp_contact: guest.contact,
            is_com: 1
          };
        } else {
          storedGuests[guestIndexInStorage] = {
            ...guestInStorage,
            name: fullCompanyName,
            contact: guestData.gstin,
            // comp_contact: guest.comp_contact
          };
        }

        localStorage.setItem("guests", JSON.stringify(storedGuests));
      }

      // console.log(storedGuests);

        const updatedGuest = {
    ...guest,
    name: fullCompanyName,
    contact: guestData.gstin,
    is_com: 1,
    comp_contact: guest.contact,
  };
  
  setGuest(updatedGuest);

const parsedGuestData = JSON.parse(formData.guest_data);
const guestIndex = parsedGuestData.id.findIndex((id) => String(id) === String(guest.id));

if (guestIndex !== -1) {
  parsedGuestData.name[guestIndex] = fullCompanyName;

  setFormData(prev => ({
    ...prev,
    guest_data: JSON.stringify(parsedGuestData),
  }));
} else {
  console.warn("Guest ID not found in guest_data");
}

//       setGuest(prev => ({
//   ...prev,
//   name: fullCompanyName,
//   contact: guestData.gstin,
//   is_com: 1,
//   comp_contact: guest.comp_contact,
// }));

// setGuestData({
//   companyName: guestData.companyName,
//   gstin: guestData.gstin,
// });

//         setGuestData({
//   companyName: guestData.companyName,
//   gstin: guestData.gstin
// });
// console.log(guestData);
// console.log(storedGuests);

      props.closeLoading();
      props.handleToast({
        toastMsg: 'Guest details updated successfully.',
        toastColor: '#4CAF50',
      });
      setShowGuestEdit(false);
    } else {
      throw new Error(result.error || 'Failed to update guest');
    }
  } catch (error) {
    console.error('Error updating guest:', error);
    props.closeLoading();
    props.handleToast({
      toastMsg: 'Something went wrong! Please try again or check Internet',
      toastColor: '#FF0000',
    });
  }
};


// useEffect(() => {
// updateGuestData()
// }, []);


  return (
    <section style={{ padding: "4rem 0" }}>
      <div className="book-room-form">
        <h2>Edit Invoice No INV{location.state.booking_id}</h2>

                    <button onClick={() => setShowGuestEdit(true)}>Edit Guest</button>

        <form onSubmit={handleSubmitEdit}>
          {guests.id.length > 0 &&
            guests.id.map((ids, index) => (
              <div key={ids} className="guest-entry">
                <label htmlFor="guest_name">Guest {index + 1} Name</label>
                <input
                  type="text"
                  name="guest_name"
                  value={guests.name[index]}
                  readOnly
                />
              </div>
            ))}

          <label htmlFor="from_date">From Date</label>
          <input
            type="datetime-local"
            name="from_date"
            value={formData.from_date}
            readOnly
          />

          <label htmlFor="to_date">To Date</label>
          <input
            type="datetime-local"
            name="to_date"
            value={formData.to_date}
            onChange={handleChange}
          />

          <label htmlFor="no_of_stayers">Number of Adult(s)</label>
          <select
            name="no_of_stayers"
            value={formData.no_of_stayers}
            readOnly
            disabled
          >
            <option value="">{formData.no_of_stayers}</option>
          </select>

          <label htmlFor="total_amount">Total Amount</label>
          <input
            type="text"
            maxLength={7}
            name="total_amount"
            value={formData.total_amount}
            onChange={handleNumberChange}
            required
          />

          <label htmlFor="advance_amount">Advance Amount</label>
          <input
            type="text"
            name="advance_amount"
            value={Number(formData.advance_amount) + Number(formData.due_collected)}
            maxLength={7}
            onChange={handleNumberChange}
            required
 disabled={getRemainingAmount(formData).toFixed(2) == "0.00"} 
          />

          <label htmlFor="payment_method">Payment Method</label>
          {/* <select
            name="payment_method"
            value={formData.payment_method}
            onChange={handleChange}
            required
          >
            <option value="">Select Payment Method</option>
            <option value="Cash">Cash</option>
            <option value="Unified Payment Interface (UPI)">
              Unified Payment Interface (UPI)
            </option>
            <option value="Credit Card">Credit Card</option>
            <option value="Debit Card">Debit Card</option>
            <option value="Credit(Due)">Credit(Due)</option>
          </select> */}
          <select
  name="payment_method"
  value={
    formData.payment_method.startsWith("Multiple Method")
      ? "Multiple Method"
      : formData.payment_method
  }
  onChange={handlePaymentMethodChange}
  required
>
  <option value="">Select Payment Method</option>
  <option value="Cash">Cash</option>
  <option value="Unified Payment Interface (UPI)">Unified Payment Interface (UPI)</option>
  <option value="Credit Card">Credit Card</option>
  <option value="Debit Card">Debit Card</option>
  <option value="Credit(Due)">Credit(Due)</option>
  <option value="Multiple Method">Multiple Method</option>
</select>

      {showMultiPayUI && (
        <div style={{ marginTop: "10px" }}>
          <h5>Select Multiple Payment Modes</h5>
          {multiPayments.map((entry, index) => (
            <div key={index} style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
              <select
                value={entry.method}
                onChange={(e) => handleMultiPaymentChange(index, "method", e.target.value)}
              >
                <option value="">Select Mode</option>
                <option value="Cash">Cash</option>
                <option value="UPI">Unified Payment Interface (UPI)</option>
                <option value="Credit Card">Credit Card</option>
                <option value="Debit Card">Debit Card</option>
                <option value="Credit(Due)">Credit(Due)</option>
              </select>
              <input
                type="text"
                placeholder="Amount"
                value={entry.amount}
                onChange={(e) => handleMultiPaymentChange(index, "amount", e.target.value)}
                min="0"
              />
            </div>
          ))}
          <button type="button" onClick={handleAddPaymentMethod}>
            + Add More
          </button>
          <br />
          <button type="button" onClick={finalizeMultiplePayment}>
            ✔ Done
          </button>
        </div>
      )}


          <label htmlFor="remarks">Remarks</label>
          <textarea
            name="remarks"
            placeholder="Add any remarks here"
            value={formData.remarks}
            maxLength={300}
            onChange={handleChange}
          />

          <label htmlFor="food_price">Food Order Amount</label>
          <input
            type="text"
            name="food_price"
            value={formData.food_price}
            onChange={handleNumberChange}
            required
          />

          <label htmlFor="food_price">GST Rate & Amount on Food Order</label>
          <div className="d-flex">
            <select
              name="food_tax_rate"
              value={formData.food_tax_rate}
              onChange={handleChange}
              required
            >
              <option value="0">GST@ 0%</option>
              <option value="3">GST@ 3%</option>
              <option value="5">GST@ 5%</option>
              <option value="12">GST@ 12%</option>
              <option value="18">GST@ 18%</option>
              <option value="28">GST@ 28%</option>
            </select>
            <input
              type="text"
              name="food_tax_amount"
              value={calculateGSTAmount(
                formData.food_price,
                formData.food_tax_rate
              )}
              readOnly
              required
            />
          </div>

          <label htmlFor="extra_charges">Extra Charges</label>
          <input
            type="text"
            name="extra_charges"
            maxLength={7}
            value={formData.extra_charges}
            onChange={handleNumberChange}
            required
          />

          <label htmlFor="tax_rate">Tax Rate & Amount on Room</label>
          <div className="d-flex">
            <select
              name="tax_rate"
              value={formData.tax_rate}
              onChange={handleChange}
              required
            >
              <option value="0.00">GST@ 0%</option>
              <option value="3.00">GST@ 3%</option>
              <option value="5.00">GST@ 5%</option>
              <option value="12.00">GST@ 12%</option>
              <option value="18.00">GST@ 18%</option>
              <option value="28.00">GST@ 28%</option>
            </select>
            <input
              type="text"
              name="tax_amount"
              value={calculateGSTAmount(
                formData.total_amount,
                formData.tax_rate
              ).toFixed(2)}
              readOnly
              required
            />
          </div>

          <label htmlFor="rest_amount">Remaining Amount to Pay</label>
          <input
            type="text"
            name="rest_amount"
            style={{backgroundColor: 'rgb(228, 227, 227)'}}
            // value={(
            //   formData.total_amount +
            //                 parseFloat(formData.extra_charges) +
            //   calculateGSTAmount(formData.total_amount, formData.tax_rate) -
            //   (formData.advance_amount + formData.due_collected)).toFixed(2)}
 value={getRemainingAmount(formData).toFixed(2)}
             readOnly
            required
          />

{/* {getRemainingAmount(formData).toFixed(2) != 0  &&
(
<> */}
<br />
<br />
          <label>Due Collection</label>
          <div className="d-flex justify-content-between border p-2 bg-danger text-light fw-semibold rounded">
                                <label htmlFor="due_collected">Amount</label>
                                <label htmlFor="collected_on">Due Date</label>

          </div>
          <div className="d-flex">
          <input
            type="text"
            name="due_collected"
            value={
              formData.due_collected}
            // maxLength={7}
            onChange={handleNumberChange}
            required
          />
          <input
            type="datetime-local"
            name="collected_on"
            value={formData.collected_on}
            onChange={handleChange}
          />

          </div>

          <select
  name="due_method"
  value={
    formData.due_method
  }
  onChange={handleDueMethodChange}
  required
>
  <option value="">Select Payment Method</option>
  <option value="Cash">Cash</option>
  <option value="Unified Payment Interface (UPI)">Unified Payment Interface (UPI)</option>
  <option value="Credit Card">Credit Card</option>
  <option value="Debit Card">Debit Card</option>
  <option value="Credit(Due)">Credit(Due)</option>
</select>


          <textarea
            name="due_remark"
            placeholder="Add Due remarks here"
            value={formData.due_remark}
            maxLength={300}
            onChange={handleChange}
          />
          {/* </>
)} */}

          <br />
          <button style={{ backgroundColor: "#007bff" }} type="submit">
            Confirm Editing Invoice
          </button>
        </form>
      </div>

      {showGuestEdit && (
  <>
 <div className="modal">
          <div className="modal-content text-center">
            <h4>Edit Guest</h4>
            <hr className="mt-0" />

            <form className="text-start" onSubmit={handleSubmitGuestEdit}>
              <label htmlFor="companyName">Company Name</label>
              <input
                type="text"
                name="companyName"
                value={guestData.companyName}
                onChange={handleGuestChange}
                required
              />

              <label htmlFor="gstin">GSTIN</label>
              <input
                type="text"
                name="gstin"
                value={guestData.gstin}
                onChange={handleGuestChange}
                required
              />

              <div className="d-flex">
                <button
                  className="w-100"
                  style={{ backgroundColor: "red" }}
                  type="button"
                  onClick={() => setShowGuestEdit(false)}
                >
                  Close
                </button>
                <button
                  className="w-100"
                  style={{ backgroundColor: "#007bff" }}
                  type="submit"
                >
                  Update Guest Details
                </button>
              </div>
            </form>
          </div>
        </div>
  </>
)}

    </section>

  );
};

export default BillEditor;
